import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React, { PropsWithChildren, ReactElement } from 'react';
import './CommonLabelAndValueList.scss';
import { FlexBox } from './flex-box';

interface Props {
  label: string;
  childrenFallback?: string | ReactElement;
  labelId?: string;
}

const CommonLabelAndValueListImpl: React.FC<PropsWithChildren<Props>> = (props) => {
  const {
    label,
    labelId,
    childrenFallback,
    children,
  } = props;

  const renderChildrenFallback = () => {
    if (typeof childrenFallback !== 'string') return childrenFallback;
    return <Text aria-labelledby={labelId} weight='semibold' align='start'>{childrenFallback || '-'}</Text>
  };

  return (
    <FlexBox
      aligns='start'
      className='common-label-and-value-list'
    >
      <Text
        id={labelId}
        align='end'
        className='common-label-and-value-list__label'
      >
        {label}
      </Text>
      {
        children || renderChildrenFallback()
      }
    </FlexBox>
  );
}

export const CommonLabelAndValueList = observer(CommonLabelAndValueListImpl);
